/**
 * Scroll plugin: tracks max scroll depth and milestones.
 */
import { clampPercent } from "../lib/redact";
import type { PluginContext } from "../lib/types";
import { throttle } from "../lib/utils";

import { registerPlugin } from "./register";

registerPlugin("scroll", (ctx: PluginContext) => {
  let maxScroll = 0;
  const milestones = new Set(ctx.config.scroll.milestones);

  const handleScroll = throttle(() => {
    if (!ctx.canTrackCategory("behavioral_events")) return;
    const doc = document.documentElement;
    const scrollTop = window.scrollY || doc.scrollTop;
    const viewport = window.innerHeight || doc.clientHeight;
    const height = Math.max(doc.scrollHeight, doc.offsetHeight);
    if (!height) return;
    const pct = clampPercent(((scrollTop + viewport) / height) * 100);
    if (pct <= maxScroll) return;
    maxScroll = pct;
    ctx.track("scroll_depth", {
      max_scroll_pct: Math.round(maxScroll),
    });
    for (const milestone of Array.from(milestones)) {
      if (maxScroll >= milestone) {
        ctx.track("scroll_depth", { milestone });
        milestones.delete(milestone);
      }
    }
  }, 200);

  return {
    onInit() {
      window.addEventListener("scroll", handleScroll, { passive: true });
    },
    onUnload() {
      window.removeEventListener("scroll", handleScroll);
    },
  };
});
